export default {
  registering: false,
  validatingOppId: false,
  oppIdValidated: false,
  submitting: true,
  formSubmitting: false,
  isSubmitted: false,
  recordNotFound: false,
  edlConnectionTimeout: false,
  isNoOppId: false,
  oppType: '',
  sfdcId: '',
  customId: false,
  isCustName: false,
  oppregStep: 'verification', // ie. verification, listing, opportunity, workload
  showOppLandingForm: true,
  showOppForm: false,
  showOppWorkload: false,
  nextPageKey: '',
  listWorkload: [],
  loadingWorkloadData: false,
  oppForm: {
    label:{
      Customer_Name: 'Customer Name',
      Customer_Street: 'Customer Street', 
      Customer_City: 'Customer City',
      Customer_Url: 'Customer URL'
    },
    placeholder: {
      Customer_Name: 'Customer Name',
      Customer_Street: 'Customer Street', 
      Customer_City: 'Customer City',
      Customer_Url: 'Customer URL',
      IndustryVerticalOther: 'Industry Vertical Other'
    }
  },
  opportunityRecord: {
    opportunity: {
      Opportunity_Id: null,
      SFDC_Oppty_Name: null,
      SFDC_Sales_Stage: null,
      SignDate: null,
      OpportunityTotalValueUSD: null,
      ESRegion: null,
      Customer_Name: null,
      Country: null,
      PrimaryESPracticeName: null,
      OpportunityDescription: null,
      OpportunityStatus: null,
      IndustryVertical: null,
      ContractLength: null,
      Client_ID: null
    },
    account: {
      Client_ID: null,
      Customer_Id: null,
      Customer_Name: null,
      Customer_Region: null,
      Customer_URL: null,
      Customer_Address: null,
      Customer_City: null,
      Customer_State: null,
      Customer_PC: null,
      Industry: null
    },
    requestor: {
      Requestor_Id: null,
      Requestor_First_Name: null,
      Requestor_Last_Name: null,
      Requestor_Phone: null,
      Requestor_Email: null
    },
    contact: {
      Id: null,
      Contact_First_Name: null,
      Contact_Last_Name: null,
      Contact_Phone: null,
      Contact_Email: null,
      Contact_Title: null
    },
    header: {
      Oppreg_Header_Notes: null,
      Client_ID: null,
      RFI_RFP: null
    }
  },
  workloadStep: 1,
  workloadForm: {
    registrationIdValidation: {
      validated: false,
      loading: false,
      success: false,
      successMessage: '',
      error: false,
      errorMessage: ''
    },
    validatedSfdcId: '',
    oppType:'',
    submitting: false, // this state is also being used for the update loading
    enteringNew: false,
    savingForLater: false,
    loadingContact: false,
    contact: {
      Id: null,
      Contact_First_Name: null,
      Contact_Last_Name: null,
      Contact_Email: null,
      Contact_Phone: null
    },
    fields: {
      Project_Id: null,
      OppReg_Id: null,
      Registration_Id: null,
      Contact_Id: null,
      Requestor_Id: null,
      SFDC_Id: null,
      Workload_Title: null,
      Campaign_Name: null,
      Solution_Business_Segment: null,
      Scope_of_Work: null,
      Is_Glacier: null,
      VMware_Workload: null,
      VMware_License: null,
      VMware_Cust_Deploy: null,
      Workload_type: 'N/A',
      Workload_Type_Date_Change: null,
      PPA_Attestation: null,
      Root_Access: null,
      DXC_Managed_Services: null,
      SaaS: null,
      Initiate_Account_Flag: null,
      Workload_Services_Storage: null,
      Workload_Services_Database: null,
      Workload_Services_App_services: null,
      Workload_Services_Compute: null,
      Workload_Services_Network: null,
      Projected_Monthly_Spend: 0,
      WL_Overall_Objective: null,
      WL_Scope_Bounderies: null,
      WL_App_Transformed: null,
      WL_Next_Pursuit: null,
      OppReg_Project_Notes: null,
      OppReg_Req_Date: null,
      Workload_Status: null,
      P_Offering_Agreed: 'Y',
      // answers table
      WL_Q1A: null,
      WL_Q2A: null,
      WL_Q3A: null,
      WL_Q4A: null,
      WL_Q5A: null,
      WL_Q6A: null,
      Attested_By: null,
      DXC_Services: null,
      WL_Q7A: '[]',
      WL_Q8A: null,
      WL_Q9A: null,
      WL_Q10A: null,
      Q1: null,
      Q2: null,
      Q3: null,
      Q4: null,
      Q5: null,
      Q6: null,
      Q7: null,
      Q8: null,
      Q9: null,
      Q10: null,
      Attested_By_Date: null,
      Attested_By_Email: null,
      Attested_By_Title: null,
      Attested_By_Manager: null,
      Attested_By_Date_2: null,
      Attested_By_Email_2: null,
      Attested_By_Title_2: null,
      Attested_By_Manager_2: null,
      // Discount_Tier_On_AWS: null,
      Discount_Tier_On_AWS: null,
      Discount_Tier_On_AWS_2: null,
      Pricing_Tier_Qualification: null,
      Pricing_Tier_Qualification_2: null
    },
    // answers: {
    //   WL_Q1A: null,
    //   WL_Q2A: null,
    //   WL_Q3A: null,
    //   WL_Q4A: null,
    //   WL_Q5A: null,
    //   WL_Q6A: null,
    //   Attested_By: null,
    //   DXC_Services: null,
    //   WL_Q7A: '[]',
    //   WL_Q8A: '[]',
    //   WL_Q9A: null,
    //   WL_Q10A: null
    // }

    oppFields: {
      opportunity: {
        Opportunity_Id: null,
        SFDC_Oppty_Name: null,
        SFDC_Sales_Stage: null,
        SignDate: null,
        OpportunityTotalValueUSD: null,
        ESRegion: null,
        Customer_Name: null,
        Country: null,
        PrimaryESPracticeName: null,
        OpportunityDescription: null,
        OpportunityStatus: null,
        IndustryVertical: null,
        IndustryVerticalOther: null,
        NatSec: null,
        Global_Registered: null,
        ContractLength: null,
        OpportunityNumber: null,
        Client_ID: null,
        Owner_Email: null,
        Owner_Name: null
      },
      account: {
        Client_ID: null,
        Customer_Id: null,
        Customer_Name: null,
        Customer_Region: null,
        Customer_URL: null,
        Customer_Address: null,
        Customer_City: null,
        Customer_State: null,
        Customer_PC: null,
        Industry: null
      },
      requestor: {
        Requestor_Id: null,
        Requestor_First_Name: null,
        Requestor_Last_Name: null,
        Requestor_Phone: null,
        Requestor_Email: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null
      },
      header: {
        Oppreg_Header_Notes: null,
        Client_ID: null,
        RFI_RFP: null
      }
    }
  },
  workloadList: [],
  workloadHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'Actions'
    },
    {
      sortable: true,
      text: 'Registration ID',
      value: 'Registration_Id'
    },
    {
      sortable: true,
      text: 'Submit Date',
      value: 'OppReg_Req_Date'
    },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Contact Email',
      value: 'Contact_Email'
    }
  ],
  newOppRegistration: {
    withError: false,
    searching: false,
    opportunityId: null,
    opportunityFound: false,
    showWorkloadForm: false,
    type: 'new'
  },
  OppRegRequestList: [],
  OppRegRequestHeaders: [
    {
      sortable: false,
      text: 'Actions'
    },
    {
      sortable: true,
      text: 'Project ID',
      value: 'Project_Id',
      align: ' d-none'
    },
    {
      sortable: true,
      text: 'OppReg ID',
      value: 'OppReg_ID'
    },
    {
      sortable: true,
      text: 'Opportunity Name',
      value: 'OpportunityName'
    },
    {
      sortable: true,
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      text: 'Workload Status',
      value: 'Workload_Status'
    },
    {
      sortable: true,
      text: 'Campaign Name',
      value: 'Campaign_Name'
    },
    {
      sortable: true,
      text: 'Workload Type',
      value: 'Workload_type'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'CustomerName'
    },
    {
      sortable: true,
      text: 'Global Registered',
      value: 'Global_Registered'
    },
    {
      sortable: true,
      text: 'AWS ACE ID',
      value: 'AWS_ACE_ID'
    },
    {
      sortable: true,
      text: 'Region',
      value: 'Region'
    },
    {
      sortable: true,
      text: 'Country',
      value: 'Country'
    },
    {
      sortable: true,
      text: 'Requestor Name',
      value: 'Requestor_First_Name'
    },
    {
      sortable: true,
      text: 'AWS Monthly Est Rev',
      value: 'AWS_Est_Rev'
    },
    {
      sortable: true,
      text: 'AWS Notes',
      value: 'AWS_Notes'
    },
    {
      sortable: true,
      text: 'Sales Stage',
      value: 'SFDC_Sales_Stage'
    },
    {
      sortable: true,
      text: 'Target Close Date',
      value: 'Closing_Date'
    },
    {
      sortable: true,
      text: 'Date Created',
      value: 'Date_Created'
    }
  ],
  OppRegRequests: {
    searching: false,
    opportunityId: null,
    showWorkloadForm: false,
    type: 'new'
  },
  selected: [],
  updateDiscount: {
    success: false,
    opportunityId: null,
    list: [],
    showDiscountPage: false,
    searching: false,
    registrationId: null,
    saving: false,
    accountRecordFound: false
    // Workload_type: ,
    // Attested_By_Date: ,
    // Attested_By_Email: ,
    // Attested_By_Manager: ,
    // Attested_By_Title: ,
    // Pricing_Tier_Qualification: ,
    // Workload_Type_Date_Change: 
  }
}
